import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledEventInformationDiv = styled.div`
  ${rtl`
  .eventInformation {
    @media ${theme.mediaQuery.tabletMax} {
      justify-content: center;

      .roomCountOption,
      .eventType{
        margin-top: ${toRem(-16)};
      }
      .checkbox {
        padding-right: ${toRem(80)};
      }
  }
  @media ${theme.mediaQuery.mobileOnly} {
    .checkbox {
      padding-right: ${toRem(16)};
    }
 }
  }
  .textAreaInput {
    height: ${toRem(200)};
  }
`}
`;
